import { useSelector } from 'react-redux';
import { getTeaseAlerts } from '../../../selectors';
const useTeaseAlerts = () => {
  return useSelector(getTeaseAlerts);
};
export default useTeaseAlerts;